import { SidePanel } from '@medly-components/layout';
import styled from 'styled-components';

import { Box, Text } from '@medly-components/core';
import Header from 'components/layout/Header';
import NavList from './NavList';
import { SideNavStyledProps } from './types';
import { MobileNavHeaderMinHeight } from 'components/common/Styled';

export const Aside = styled(SidePanel)<SideNavStyledProps>`
    @keyframes expand {
        0% {
            z-index: 4;
        }
        100% {
            z-index: 4;
        }
    }
    @keyframes collapse {
        0% {
            z-index: 4;
        }
        100% {
            z-index: 0;
        }
    }
    position: inherit;
    height: 100%;
    transition: width 200ms ease-out;
    width: ${({ isExpanded, theme }) => (isExpanded ? theme.sideNav.openSize : theme.sideNav.closeSize)};
    animation: ${({ isHovered }) => (isHovered === true ? 'expand' : 'collapse')} 2s;
    animation-fill-mode: forwards;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        z-index: 10;
        position: absolute;
        animation: unset;
        width: ${({ isExpanded, theme }) => (isExpanded ? theme.sideNav.openSize : 0)};
    }
`;

export const Nav = styled('nav')<SideNavStyledProps>`
    height: 100%;
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    overflow: hidden;
    transition: all 200ms ease-out;
    background-color: ${({ theme }) => theme.sideNav.bgColor};
    width: ${({ isHovered, isExpanded, theme }) => (isHovered || isExpanded ? theme.sideNav.openSize : theme.sideNav.closeSize)};

    & > ${NavList.Style}:first-of-type {
        padding-top: 3.2rem;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        width: ${({ isHovered, isExpanded }) => (isHovered || isExpanded ? '26.4rem' : 0)};
        & > ${NavList.Style}:first-of-type {
            padding-top: 0;
        }
    }
`;

export const ToggleSwitchStyled = styled.div`
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        display: none;
    }
`;

export const MobileNavHeader = styled(Header)`
    display: flex;
    width: 100%;
    min-height: ${MobileNavHeaderMinHeight};
    padding: 0 2.4rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
    border-radius: 0;
    background: ${({ theme }) => theme.sideNav.bgColor};
    align-items: center;
    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        display: none;
    }
`;

export const LogoWrapper = styled.div`
    margin-right: 2rem;
    display: flex;
    justify-content: center;
    flex: 1;
`;

export const MobileBackdrop = styled.div`
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    background: ${({ theme }) => theme.colors.darkBlue};
    opacity: 0.4;
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        display: block;
    }
`;

export const CloseNav = styled.span`
    width: 32px;
    height: 32px;
    border-radius: 50px;
    border: 1px solid ${({ theme }) => theme.colors.silverGrey[500]};
    margin-left: auto;
    margin-right: 2.4rem;
    margin-top: 2.4rem;
    margin-bottom: 0.8rem;
    display: none;
    justify-content: center;
    align-items: center;
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        display: inline-flex;
    }
`;

export const LegendsPopoverWrapper = styled.div`
    position: fixed;
    left: ${({ theme }) => theme.sideNav.openSize};
    z-index: 11;
    box-sizing: border-box;
    top: 50%;
    transform: translateY(-50%);
    overflow-y: auto;
    max-height: 100vh;
    box-shadow: 0 0.2rem 0.8rem 0 ${({ theme }) => theme.colors.grey[500]};
    transition: all 200ms ease-out;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        top: ${MobileNavHeaderMinHeight};
        left: 0;
        width: 100%;
        height: calc(100% - ${MobileNavHeaderMinHeight});
        background: ${({ theme }) => theme.colors.grey[50]};
        padding: 4rem 3.2rem;
        transform: initial;
    }
`;

export const LegendHeader = styled(Text)`
    color: ${({ theme }) => theme.colors.darkBlue};
    display: none;
    padding-bottom: 2.4rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        display: block;
    }
`;

export const LegendsWrapper = styled(Box)`
    background: ${({ theme }) => theme.colors.white};
    padding: 0 0 0 1.6rem;
    width: 20.8rem;
    height: 24rem;
    border-radius: 0.4rem;
    box-sizing: border-box;
    box-shadow: 0 0.2rem 0.8rem 0 ${({ theme }) => theme.colors.grey[500]};
    position: relative;
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        background: ${({ theme }) => theme.colors.white};
        width: 100%;
    }
`;

export const CloseLegends = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 50px;
    border: 1px solid ${({ theme }) => theme.colors.silverGrey[500]};
    margin-left: auto;
    margin-right: 1.6rem;
    margin-top: 1.6rem;
    display: none;
    justify-content: center;
    align-items: center;
    position: absolute;
    cursor: pointer;
    svg,
    path {
        fill: ${({ theme }) => theme.colors.darkBlue} !important;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        display: inline-flex;
        right: 0;
    }
`;
